import { EndpointBuilder } from "@reduxjs/toolkit/dist/query";
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "services/api";
import { BookableExperienceAvailabilityByItemIdResponse } from "./types";

export const bookableExperienceApi = createApi({
  reducerPath: "bookableExperienceService",
  baseQuery,
  endpoints: (builder: EndpointBuilder<any, any, any>) => ({
    getBookableExperienceAvailabilityByItemId: builder.query<
      BookableExperienceAvailabilityByItemIdResponse,
      string
    >({
      query: (item_id: string) => ({
        url: `/bookable-experience/details/item?item_id=${item_id}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetBookableExperienceAvailabilityByItemIdQuery } =
  bookableExperienceApi;
